import React from 'react';

import Screen, {backButton, useReportButton} from 'editor/screens/Screen';
import {COPY} from 'text/errors';

/** A project whose processing failed, or whose uploaded file is gone (DQ17). `code` is what the ticket says the open failed with. */
export default function ProcessingError({projectId, code}) {
    const report = useReportButton(projectId, code);
    const copy = COPY.screens.processingError;

    return <Screen title={copy.title} body={[copy.body]} buttons={[report, backButton]}/>;
}
